import {
  BIGQUERY,
  MYSQL,
  POSTGRES,
  REDSHIFT,
  SNOWFLAKE,
  SQLSERVER,
} from '@/util/enums/EnumDbType';
import { TrevorIconName } from '@trevor/ui-components';

const POSTGRES_DB = {
  name: 'Postgres',
  enum: POSTGRES,
  link: '/setup/postgres',
  iconName: 'postgres' as TrevorIconName,
};

const MYSQL_DB = {
  name: 'MySQL',
  enum: MYSQL,
  link: '/setup/mysql',
  iconName: 'my-sql' as TrevorIconName,
};

const REDSHIFT_DB = {
  name: 'Redshift',
  enum: REDSHIFT,
  link: '/setup/redshift',
  iconName: 'redshift' as TrevorIconName,
};

const BIGQUERY_DB = {
  name: 'BigQuery',
  enum: BIGQUERY,
  link: '/setup/bigquery',
  iconName: 'big-query' as TrevorIconName,
};

const PANOPLY_DB = {
  name: 'Panoply',
  link: '/setup/bigquery',
  iconName: 'panoply' as TrevorIconName,
};

const SNOWFLAKE_DB = {
  name: 'Snowflake',
  enum: SNOWFLAKE,
  link: '/setup/snowflake',
  iconName: 'snowflake' as TrevorIconName,
};

const SQL_SERVER_DB = {
  name: 'SQL Server',
  enum: SQLSERVER,
  link: '/setup/sqlserver',
  iconName: 'sql-server' as TrevorIconName,
};

const MARIADB_DB = {
  name: 'MariaDB',
  link: '/setup/mysql',
  iconName: 'maria-db' as TrevorIconName,
};

export const DATASOURCE_OPTIONS: {
  name: string;
  enum?: string;
  link: string;
  iconName: TrevorIconName;
}[] = [
  POSTGRES_DB,
  MYSQL_DB,
  SNOWFLAKE_DB,
  REDSHIFT_DB,
  PANOPLY_DB,
  BIGQUERY_DB,
  SQL_SERVER_DB,
  MARIADB_DB,
];
